import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage, useIntl} from "react-intl";

import {greyishBlue100, greyishBlue600, primaryColor} from "assets/jss/main";

import {formatDateTime, formatMoney} from "views/personalShopper/components/formatters";

import SideCard from "./SideCard";

const MAX_EVENTS = 30;

HistoryCard.propTypes = {
    conversation: PropTypes.object.isRequired,
};

/**
 * The events of the relationship, newest first: the first contact, the alerts opened and
 * handled, the takeovers, the purchases, the suspension, the privacy requests.
 */
function HistoryCard({conversation}) {
    const intl = useIntl();
    const events = [];
    const push = (at, label) => at && events.push({at, label});

    push(conversation.createdAt, intl.formatMessage({id: "personalShopper.history.created"}));
    (conversation.escalations || []).forEach((escalation) => {
        push(escalation.createdAt, intl.formatMessage({id: "personalShopper.history.escalationOpened"}, {category: intl.formatMessage({id: `personalShopper.escalation.${escalation.category}`})}));
        push(escalation.handledAt, intl.formatMessage({id: "personalShopper.history.escalationHandled"}, {who: escalation.handledBy || ""}));
    });
    (conversation.assistedPurchases || []).forEach((purchase) => {
        push(purchase.completedAt, intl.formatMessage({id: "personalShopper.history.purchase"}, {order: purchase.orderNumber, total: formatMoney(purchase.total, purchase.currencyCode)}));
    });
    if (conversation.handledBy) {
        push(conversation.handledSince, intl.formatMessage({id: "personalShopper.history.takeOver"}, {who: conversation.handledBy}));
    }
    push(conversation.suspendedAt, intl.formatMessage({id: "personalShopper.history.suspended"}));
    push(conversation.erasureRequestedAt, intl.formatMessage({id: "personalShopper.history.erasureRequested"}));
    push(conversation.marketingOptOutAt, intl.formatMessage({id: "personalShopper.history.marketingOptOut"}));
    push(conversation.profile?.updatedAt, intl.formatMessage({id: "personalShopper.history.profileUpdated"}));

    events.sort((a, b) => (a.at < b.at ? 1 : -1));
    const shown = events.slice(0, MAX_EVENTS);

    return (
        <SideCard titleId="personalShopper.history.title">
            {shown.length === 0 && <div style={{color: greyishBlue600, fontSize: "13px"}}><FormattedMessage id="personalShopper.history.empty" /></div>}
            <div style={{borderLeft: `2px solid ${greyishBlue100}`, marginLeft: "5px", paddingLeft: "12px"}}>
                {shown.map((event, index) => (
                    <div key={`${event.at}-${index}`} style={{position: "relative", paddingBottom: "10px", fontSize: "13px"}}>
                        <span style={{position: "absolute", left: "-18px", top: "5px", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: primaryColor}} />
                        <div style={{color: greyishBlue600, fontSize: "11px"}}>{formatDateTime(event.at)}</div>
                        <div>{event.label}</div>
                    </div>
                ))}
            </div>
        </SideCard>
    );
}

export default HistoryCard;
